module.exports = __webpack_public_path__ + "img/stop_process.39990f81.png";